import React from 'react';
import { Badge } from '../../components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Sparkles, GraduationCap } from 'lucide-react';

/**
 * Top hero banner for /courses — explains the feature and shows the user's
 * remaining monthly quota in plain language. Quota = { tier, used, limit,
 * remaining }. For Pro users limit/remaining are null (unlimited).
 */
const CourseHero = ({ quota }) => {
  const isPro = quota?.tier === 'pro';
  const remaining = quota?.remaining;
  const limit = quota?.limit;

  return (
    <Card className="bg-gradient-to-br from-[#07070d] via-[#0a0a14] to-[#0d0d1f] border-purple-500/20 text-white overflow-hidden">
      <CardHeader className="pb-2">
        <div className="flex items-start justify-between gap-4">
          <div>
            <CardTitle className="text-2xl md:text-3xl font-bold flex items-center gap-3">
              <GraduationCap className="w-7 h-7 text-cyan-300" />
              AI Course Creator
            </CardTitle>
            <p className="text-sm text-gray-300 mt-2 max-w-2xl">
              Type any investing topic — options, ETFs, value investing,
              dividends, macro — and our AI builds a free, structured course
              with real YouTube lessons and curated articles. Educational use
              only. Not financial advice.
            </p>
          </div>
          <Badge
            className={
              isPro
                ? 'bg-emerald-600/30 text-emerald-200 border border-emerald-500/30'
                : 'bg-purple-600/30 text-purple-200 border border-purple-500/30'
            }
            data-testid="courses-quota-badge"
          >
            <Sparkles className="w-3.5 h-3.5 mr-1" />
            {isPro
              ? 'Pro · unlimited courses'
              : `${remaining ?? 0} of ${limit ?? 1} free generation left this month`}
          </Badge>
        </div>
      </CardHeader>
      <CardContent className="pt-2 text-xs text-gray-400">
        Free plan includes 1 AI course per calendar month. Upgrade to Pro for
        unlimited generations, deeper outlines, and downloadable progress.
      </CardContent>
    </Card>
  );
};

export default CourseHero;
